module.exports = __webpack_public_path__ + "img/02.89d706c1.png";